var _ellipse, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 282,
    viewBox: "0 0 243 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 121.5,
    cy: 251.5,
    rx: 121.5,
    ry: 10.5,
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1508_12441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6977 176.406V226.082L47.6184 254.663",
    stroke: "#6562CF",
    strokeWidth: 0.99503,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0462 176.406V226.082L113.128 254.663",
    stroke: "#6562CF",
    strokeWidth: 0.99503,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2306 226.664V254.668",
    stroke: "#6562CF",
    strokeWidth: 0.99503,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7967 169.586H91.635C91.635 171.394 90.9167 173.127 89.6383 174.405C88.3598 175.684 86.6258 176.402 84.8178 176.402H76.6202C74.8122 176.402 73.0783 175.684 71.7998 174.405C70.5214 173.127 69.8031 171.394 69.8031 169.586H69.7967Z",
    fill: "white",
    stroke: "#6562CF",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5084 157.385H60.9043L58.3308 143.047H64.9349L67.5084 157.385Z",
    fill: "white",
    stroke: "#6562CF",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.616 160.438V165.994C118.616 166.729 116.603 167.419 113.103 168.005C106.38 169.132 94.1726 169.886 80.2273 169.886C59.0282 169.886 41.8406 168.144 41.8406 165.994V160.438C41.8406 161.526 46.2547 162.51 53.3679 163.217C60.2915 163.905 69.7716 164.329 80.2273 164.329C90.6831 164.329 100.165 163.903 107.089 163.217C109.398 162.987 111.422 162.729 113.103 162.448C116.603 161.862 118.616 161.172 118.616 160.438Z",
    fill: "white",
    stroke: "#6562CF",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.616 160.438C118.616 161.173 116.603 161.863 113.103 162.449C111.422 162.73 109.398 162.988 107.089 163.218C100.165 163.906 90.6852 164.33 80.2273 164.33C69.7695 164.33 60.2915 163.904 53.3679 163.218C46.2547 162.511 41.8406 161.527 41.8406 160.438C41.8406 158.289 59.0282 156.547 80.2273 156.547C97.0827 156.547 111.401 157.648 116.563 159.179C117.894 159.576 118.616 159.997 118.616 160.438Z",
    fill: "white",
    stroke: "#6562CF",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6092 145.006H56.4492C45.6931 145.006 35.4376 136.435 33.5394 125.865L29.2127 101.739C27.3167 91.1684 34.4981 82.5977 45.2542 82.5977H57.4206C68.1768 82.5977 78.4323 91.1684 80.3283 101.739L84.6572 125.865C86.5532 136.435 79.3718 145.006 68.6092 145.006Z",
    fill: "white",
    stroke: "#6562CF",
    strokeWidth: 0.829191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6986 226.082H84.0484",
    stroke: "#6562CF",
    strokeWidth: 0.99503,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3776 60.7985C63.5441 51.6506 57.5344 41.5058 59.162 36.0234C62.3426 25.2972 76.1643 38.279 81.6479 25.0011C81.6479 25.0011 89.7581 30.6816 90.5953 29.5655L111.573 27.6103C119.191 19.4847 116.473 10.588 113.369 7.16315C113.369 7.16315 103.782 -3.75476 92.8663 1.53806C87.0142 4.37723 82.2486 13.2824 81.0748 20.2813C79.8072 27.8488 68.4866 5.3719 52.0147 12.9842C41.2309 17.9874 49.4114 33.5634 36.8061 33.9361C20.249 34.4281 12.3859 50.8604 31.7955 65.0583C41.1265 71.8932 51.6227 66.8709 56.3776 60.7985Z",
    fill: "#6562CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8625 21.5547L81.8522 25.412",
    stroke: "#FFB000",
    strokeWidth: 1.65838,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6748 74.5851C31.0185 70.5265 30.8823 66.0611 28.3706 64.6113C25.859 63.1615 21.9229 65.2763 19.5792 69.3349C17.2355 73.3935 17.3717 77.8589 19.8833 79.3087C22.395 80.7585 26.331 78.6437 28.6748 74.5851Z",
    fill: "#6562CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.475 62.8711L30.7387 65.4653",
    stroke: "#FFB000",
    strokeWidth: 1.65838,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7093 110.425C63.7093 110.425 36.4578 149.458 64.6189 159.52C83.349 166.212 120.965 165.577 144.062 164.399C149.606 164.117 154.889 161.959 159.045 158.279C163.2 154.6 165.982 149.618 166.933 144.15C167.583 140.424 166.899 136.588 165.001 133.316C163.103 130.043 160.112 127.545 156.554 126.259C140.528 120.47 113.489 110.412 97.1707 107.656C97.1707 107.656 83.7346 114.696 63.7093 110.425Z",
    fill: "#FFBE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.227 235.227C189.227 235.227 181.821 238.034 187.252 253.946H188.464C188.464 253.946 189.685 245.938 191.04 245.87C192.394 245.802 196.191 253.946 198.157 253.946H213.947C213.947 253.946 213.608 250.724 211.178 250.377C208.747 250.029 203.721 244.898 203.721 244.898L189.227 235.227Z",
    fill: "#6562CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.565 128.409C171.384 131.484 179.716 198.545 203.712 244.898C203.712 244.898 190.597 243.963 189.225 235.226C189.225 235.226 149.416 194.198 148.353 169.706C147.29 145.214 155.528 126.52 161.565 128.409Z",
    fill: "#A85F2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.635 235.227C146.635 235.227 139.23 238.034 144.66 253.946H145.872C145.872 253.946 147.093 245.938 148.448 245.87C149.803 245.802 153.599 253.946 155.566 253.946H171.356C171.356 253.946 171.017 250.724 168.586 250.377C166.156 250.029 161.13 244.898 161.13 244.898L146.635 235.227Z",
    fill: "#6562CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.681 235.29C146.681 235.29 130.448 182.894 134.787 162.362C140.073 137.361 154.295 123.845 161.106 128.409C167.916 132.974 149.425 203.414 156.184 235.29C157.02 239.224 161.625 245.326 161.625 245.326C161.625 245.326 144.139 243.507 146.681 235.29Z",
    fill: "#B6732B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8245 46.1522C57.807 43.7368 69.6816 37.7603 83.2988 35.132C96.916 32.5037 103.616 37.1384 105.693 40.2438C108.492 44.4205 104.166 49.3811 106.198 61.7069C107.723 70.9635 111.324 77.5491 109.447 82.3116C106.584 89.5725 98.8162 89.6981 98.5691 106.742C98.4754 113.106 67.4021 113.474 63.8444 110.422C60.2867 107.37 46.8996 52.5674 54.8245 46.1522Z",
    fill: "#FFBE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2704 50.79C47.9458 69.2968 59.8928 98.1698 67.0167 98.1698C82.1975 98.1762 108.375 69.9592 108.375 69.9592L106.927 64.6983L70.8279 82.6385C70.8279 82.6385 68.6783 60.2958 66.6332 52.5216C64.5433 44.5728 54.4753 41.3651 52.2704 50.79Z",
    fill: "#B6732B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.854 65.313C107.435 63.8413 117.784 61.2492 118.836 61.9052C119.889 62.5612 128.257 64.148 128.257 64.148C128.257 64.148 128.091 66.148 124.774 65.8029C120.922 65.4025 120.106 66.2119 120.106 66.2119C120.106 66.2119 120.639 68.3183 119.444 69.1213C118.248 69.9243 119.829 71.0595 118.165 72.6186C117.19 73.5302 117.149 74.6634 115.877 74.904C114.606 75.1447 106.821 71.2065 105.535 68.7976C104.435 66.7635 104.915 66.1863 105.854 65.313Z",
    fill: "#B6732B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7964 39.1347C71.2825 38.0932 82.8567 30.7024 88.8515 22.7578L92.6968 33.9398C92.6968 33.9398 95.2532 45.3008 80.8861 46.0803C71.9834 46.551 68.7964 39.1347 68.7964 39.1347Z",
    fill: "#B6732B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5345 43.3072C84.3173 38.451 85.2504 29.0368 88.7037 22.9495C88.7548 22.8856 88.8038 22.8217 88.8507 22.7578L92.6981 33.9398C92.6981 33.9398 93.9955 39.7098 89.5345 43.3072Z",
    fill: "#A85F2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.329 14.4648C111.981 14.7034 114.507 20.0431 112.814 24.9014C111.12 29.7597 104.373 39.4572 99.7588 39.1228C92.2855 38.5839 88.4488 28.2219 88.6128 23.8897C88.6128 23.8897 88.6746 18.9227 94.1645 20.0559C98.6787 20.9824 103.15 19.7619 105.087 17.3083C107.023 14.8546 108.329 14.4648 108.329 14.4648Z",
    fill: "#B6732B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1508_12441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 282,
    fill: "white",
    transform: "translate(18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.41a13c88821491d1d6da25d5d425ef47.svg";
export { ForwardRef as ReactComponent };